var jsscroller,
    scrollY = 0,
    scrollTagergetY = 0,
    windowsMulti = 1,
    dragging = !1,
    mouseYscrollbar = 0,
    mouseYscroller = 0;
-1 != navigator.appVersion.indexOf("Win") && (windowsMulti = 1.2);
var index_scroll_large,
    index_scroll_small,
    slidetimer,
    scrollAble = !1,
    inTransition = !1,
    cursor = { x: 0.9 * $(window).width(), y: $(window).height() - 0.1 * $(window).width() },
    targetCursor = { x: 0.9 * $(window).width(), y: $(window).height() - 0.1 * $(window).width() },
    active_hover = !1,
    pagetransition = 0;
pagetransitiontext = 0;
var insta_hover = !1,
    insta_target = 0,
    ajaxurl = wp_url + "/wp-admin/admin-ajax.php",
    isMobile = !1;
/Mobi/.test(navigator.userAgent) && ((isMobile = !0), $(".cursor").css({ display: "none" }), $(".pointer").css({ display: "none" }));
var loading_animation,
    loading_animation_,
    dragging_animation,
    logo_animation,
    loading_text = [
        "",
        '<div>E<span style="margin-left:-0.03em;">a</span>ts&nbsp;&amp;</div><div>T<span style="margin-left:-0.05em;">r</span>eats</div>',
        "<div>Yoga</div><div>Wellness</div>",
        "<div>News&nbsp;&amp;</div><div>Events</div>",
        "<div>About</div><div>Joanna</div>",
        "<div>Say</div><div>Hello</div>",
    ],
    cbk = function (e) {
        e.currentTarget.href === window.location.href &&
            (e.preventDefault(),
            e.stopPropagation(),
            $("div.menu_button").hasClass("open") &&
                ($("div.menu_button").removeClass("open"),
                TweenLite.to($(".mobile_menu"), 0.8, {
                    width: 0,
                    ease: Power2.easeInOut,
                    onComplete: function () {
                        TweenLite.set($("div.mobile_menu .menu_items a"), { autoAlpha: 0 });
                    },
                })));
    },
    validateEmail = function (e) {
        return !!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(e);
    };
function runscript() {
    if (
        ($(".content").hasClass("index")
            ? indexjs()
            : $(".content").hasClass("cate")
            ? catejs()
            : $(".content").hasClass("about")
            ? aboutjs()
            : $(".content").hasClass("article")
            ? articlejs()
            : $(".content").hasClass("contact") && contactjs(),
        !isMobile)
    ) {
        TweenLite.set($("#scrollbar .scroller"), { height: $("#scrollbar").height() / ($(".scrolling_content").height() / $(window).height()) }), TweenLite.set($("#scrollbar .scroller"), { top: 0 });
        var e = $(".content").attr("data-menu");
        1 == e
            ? $("div.top_menu a.eats").addClass("active")
            : 2 == e
            ? $("div.top_menu a.yoga").addClass("active")
            : 3 == e
            ? $("div.top_menu a.events").addClass("active")
            : 4 == e
            ? $("div.top_menu a.about").addClass("active")
            : 5 == e && $("div.top_menu a.contact").addClass("active");
    }
}
function indexjs() {
    if (
        ((index_scroll_large = 1),
        (index_scroll_small = 2),
        TweenLite.set([$(".large_bg .bg" + index_scroll_large + " .active_detail .open_link div"), $(".large_bg .bg" + index_scroll_large + " .active_detail .cover_title div")], { autoAlpha: 1 }),
        768 < $(window).width()
            ? (TweenLite.set([$(".large_bg .bg"), $(".small_bg .bg"), $(".small_bg .bg")], { force3D: !0 }),
              TweenLite.set([$(".large_bg .bg .obj_bg"), $(".small_bg .bg .obj_bg")], { force3D: !0, rotation: 0.01 }),
              TweenLite.set($(".large_bg .bg" + index_scroll_large), { width: 0.6 * $(window).width() }),
              TweenLite.set($(".small_bg .bg" + index_scroll_small), { height: $(window).height() }),
              TweenLite.fromTo($(".small_bg .bg" + index_scroll_small + " .obj_bg"), 1.6, { scale: 1.1 }, { scale: 1, ease: Power2.easeInOut }),
              TweenLite.fromTo($(".large_bg .bg" + index_scroll_large + " .obj_bg"), 1.6, { scale: 1.1 }, { scale: 1, ease: Power2.easeInOut }),
              TweenLite.to($(".content.index .front_nav"), 0.8, { y: 0, ease: Power2.easeInOut, delay: 1.6 }),
              (slidetimer = setTimeout(indexslideshow.slideshowplay, 8e3)),
              $(".content.index .small_bg .cover_title")
                  .mouseenter(function () {
                      mouseevents.mousehover();
                  })
                  .mouseleave(function () {
                      mouseevents.mouseout();
                  })
                  .mouseup(function () {
                      scrollAble && ((scrollAble = !1), indexslideshow.index_next());
                  }),
              $(".content.index .front_nav .next_prev .next_btn")
                  .mouseenter(function () {
                      mouseevents.mousehover(), clearTimeout(slidetimer), TweenLite.to($("span", this), 0.2, { scaleX: 1, transformOrigin: "0% 50%", ease: Power1.easeInOut });
                  })
                  .mouseleave(function () {
                      mouseevents.mouseout(),
                          TweenLite.to($("span", this), 0.2, {
                              scaleX: 0,
                              transformOrigin: "100% 50%",
                              ease: Power1.easeInOut,
                              onComplete: function () {
                                  slidetimer = setTimeout(indexslideshow.slideshowplay, 5e3);
                              },
                          });
                  })
                  .mouseup(function () {
                      scrollAble && ((scrollAble = !1), indexslideshow.index_next());
                  }),
              $(".content.index .front_nav .next_prev .prev_btn")
                  .mouseenter(function () {
                      mouseevents.mousehover(),
                          clearTimeout(slidetimer),
                          TweenMax.killTweensOf($(".content.index .front_nav .next_prev .next_btn span")),
                          TweenLite.to($(".content.index .front_nav .next_prev .next_btn span"), 0.2, { scaleX: 0, ease: Power1.easeInOut }),
                          TweenLite.to($("span", this), 0.2, { scaleX: 1, transformOrigin: "0% 50%", ease: Power1.easeInOut });
                  })
                  .mouseleave(function () {
                      mouseevents.mouseout(), (slidetimer = setTimeout(indexslideshow.slideshowplay, 5e3)), TweenLite.to($("span", this), 0.2, { scaleX: 0, transformOrigin: "100% 50%", ease: Power1.easeInOut });
                  })
                  .mouseup(function () {
                      scrollAble && ((scrollAble = !1), indexslideshow.index_prev());
                  }))
            : (TweenLite.set([$(".large_bg .bg")], { force3D: !0 }),
              TweenLite.set([$(".large_bg .bg .obj_bg")], { force3D: !0, rotation: 0.01 }),
              TweenLite.set($(".large_bg .bg" + index_scroll_large), { width: $(window).width() }),
              TweenLite.fromTo($(".large_bg .bg" + index_scroll_large + " .obj_bg"), 1.6, { scale: 1.1 }, { scale: 1, ease: Power2.easeInOut })),
        $(".open_page a").attr("href", $(".large_bg .bg" + index_scroll_large + " .active_detail a").attr("href")),
        $(".content.index .large_bg .cover_title")
            .mouseenter(function () {
                mouseevents.mousehover(), isMobile || TweenLite.to($(".open_page span"), 0.8, { scaleX: 2, ease: Power4.easeInOut });
            })
            .mouseleave(function () {
                mouseevents.mouseout(), isMobile || TweenLite.to($(".open_page span"), 0.8, { scaleX: 1, ease: Power4.easeInOut });
            })
            .mouseup(function () {
                scrollAble &&
                    ($(this).addClass("in_transition"),
                    (pagetransition = 1),
                    (pagetransitiontext = $(this).attr("data-pagetransition")),
                    isMobile || (TweenLite.to($(".pointer #pointer"), 0.2, { scale: 1, autoAlpha: 0, ease: Power1.easeOut, force3D: !1 }), TweenLite.to($("div.cursor #drag"), 0.2, { autoAlpha: 0, ease: Power2.easeOut })));
            }),
        $(".open_page a")
            .mouseenter(function () {
                mouseevents.mousehover(), isMobile || TweenLite.to($(".open_page span"), 0.8, { scaleX: 2, ease: Power4.easeInOut });
            })
            .mouseleave(function () {
                mouseevents.mouseout(), isMobile || TweenLite.to($(".open_page span"), 0.8, { scaleX: 1, ease: Power4.easeInOut });
            })
            .mouseup(function () {
                (pagetransition = 1),
                    (pagetransitiontext = $(".large_bg .bg" + index_scroll_large + " .active_detail a").attr("data-pagetransition")),
                    isMobile || (TweenLite.to($(".pointer #pointer"), 0.2, { scale: 1, autoAlpha: 0, ease: Power1.easeOut, force3D: !1 }), TweenLite.to($("div.cursor #drag"), 0.2, { autoAlpha: 0, ease: Power2.easeOut }));
            }),
        !isMobile)
    ) {
        Draggable.create(".drag_control", {
            type: "x",
            throwProps: !1,
            lockAxis: !0,
            maxDuration: 0.1,
            minDuration: 0.1,
            zIndexBoost: !1,
            onPress: function () {},
            onRelease: function () {
                TweenLite.set($(".drag_control"), { x: 0 });
            },
            onDrag: function () {
                scrollAble &&
                    (1 < this.x
                        ? (TweenMax.killTweensOf($(".content.index .front_nav .next_prev .next_btn span")),
                          TweenLite.to($(".content.index .front_nav .next_prev .next_btn span"), 0.2, { scaleX: 0, ease: Power1.easeInOut }),
                          indexslideshow.index_prev())
                        : this.x < 1 && (TweenMax.killTweensOf($(".content.index .front_nav .next_prev .next_btn span")), indexslideshow.index_next())),
                    (scrollAble = !1);
            },
        });
        loading_animation_.pause(),
            TweenMax.to($("div.cursor #loader .circle"), 0.6, { drawSVG: "100%", ease: Power1.easeOut }),
            TweenMax.to($("div.cursor #loader"), 0.4, {
                autoAlpha: 0,
                ease: Power1.easeInOut,
                delay: 0.2,
                onComplete: function () {
                    loading_animation.pause(), dragging_animation.play(), TweenMax.to($("div.cursor #drag"), 0.4, { autoAlpha: 1, ease: Power1.easeInOut });
                },
            });
    }
}
function catejs() {
    TweenLite.set([$(".scrolling_content"), $(".half_txt .entry.top"), $(".content.cate .large_text")], { rotation: 0.01, force3D: !0 }),
        new SplitText(".half_txt .entry.top .bodytext", { type: "lines" }),
        TweenLite.set($(".half_txt .entry.top .bodytext"), { autoAlpha: 1 }),
        TweenMax.staggerFromTo($(".half_txt .entry.top .bodytext div"), 2, { autoAlpha: 0, rotation: -5, yPercent: -100 }, { autoAlpha: 1, rotation: 0, yPercent: 0, ease: Power3.easeOut, delay: 0.2 }, 0.04),
        TweenLite.set($(".footer"), { force3D: !0 }),
        $(".half_img").length &&
            (TweenLite.set($(".half_img"), { force3D: !0 }),
            TweenLite.set($(".half_img .bg"), { force3D: !0, rotation: 0.01 }),
            $(".hover_entry .cover").each(function () {
                $(".half_img").append('<div class="bg bg' + $(this).attr("data-hover") + ' hoverdisplay" style="' + $(this).attr("style") + '"></div>');
            })),
        $(".category").length && TweenLite.set($(".category"), { force3D: !0 }),
        $(".parallax_bg").length && TweenLite.set($(".parallax_bg"), { force3D: !0, rotation: 0.01 }),
        isMobile || TweenLite.to($("#scrollbar"), 0.2, { autoAlpha: 1 }),
        $(".category span")
            .mouseenter(function () {
                mouseevents.mousehover();
            })
            .mouseleave(function () {
                mouseevents.mouseout();
            })
            .mouseup(function () {
                $(this).addClass("active"), $(this).siblings().removeClass("active");
                var e = $(this).attr("data-ajax");
                (scrollTagergetY = -1 * ($(".entry_wrapper").position().top - 0.225 * $(window).height())),
                    isMobile || (TweenLite.to($("#scrollbar"), 0.2, { autoAlpha: 0 }), TweenLite.set($("div.cursor #loader .circle"), { drawSVG: "0%" }), loading_animation_.restart(), loading_animation.restart()),
                    TweenLite.to($(".entry_wrapper"), 0.4, {
                        autoAlpha: 0,
                        ease: Power1.easeOut,
                        onComplete: function () {
                            $(".entry_wrapper").html(""),
                                $(".half_img").html(""),
                                $.ajax({
                                    type: "POST",
                                    url: ajaxurl,
                                    data: { action: "search_post", search: e },
                                    success: function (e) {
                                        isMobile ||
                                            (TweenLite.set($("#scrollbar .scroller"), { height: $("#scrollbar").height() / ($(".scrolling_content").height() / $(window).height()) }),
                                            TweenLite.to($("#scrollbar"), 0.2, { autoAlpha: 1 }),
                                            loading_animation_.pause(),
                                            TweenMax.to($("div.cursor #loader .circle"), 0.6, {
                                                drawSVG: "100%",
                                                ease: Power1.easeOut,
                                                onComplete: function () {
                                                    loading_animation.pause();
                                                },
                                            })),
                                            $(".entry_wrapper").html(e),
                                            $(".hover_entry .cover").each(function () {
                                                $(".half_img").append('<div class="bg bg' + $(this).attr("data-hover") + ' hoverdisplay" style="' + $(this).attr("style") + '"></div>');
                                            }),
                                            $(".half_txt .hover_entry")
                                                .mouseenter(function () {
                                                    mouseevents.mousehover(),
                                                        TweenLite.to($(".half_img .bg.bg" + $(this).attr("data-hover")), 0.2, { opacity: 1, ease: Power1.easeIn }),
                                                        TweenLite.to($(".title span", this), 0.2, { x: 0, autoAlpha: 1, ease: Power1.easeInOut });
                                                })
                                                .mouseleave(function () {
                                                    mouseevents.mouseout(),
                                                        TweenLite.to($(".title span", this), 0.2, { x: -10, autoAlpha: 0, ease: Power1.easeInOut }),
                                                        scrollAble && TweenLite.to($(".half_img .bg.bg" + $(this).attr("data-hover")), 0.2, { opacity: 0, ease: Power1.easeOut });
                                                })
                                                .mouseup(function () {
                                                    scrollAble && ((pagetransition = 2), $(".transition_bg .transition_image .bg").css("background-image", $(".half_img .bg.bg" + $(this).attr("data-hover")).css("background-image")));
                                                }),
                                            TweenLite.to($(".entry_wrapper"), 0.4, { autoAlpha: 1, ease: Power1.easeIn });
                                    },
                                });
                        },
                    });
            }),
        $(".half_txt .hover_entry")
            .mouseenter(function () {
                mouseevents.mousehover(), TweenLite.to($(".half_img .bg.bg" + $(this).attr("data-hover")), 0.2, { opacity: 1, ease: Power1.easeIn }), TweenLite.to($(".title span", this), 0.2, { x: 0, autoAlpha: 1, ease: Power1.easeInOut });
            })
            .mouseleave(function () {
                mouseevents.mouseout(),
                    TweenLite.to($(".title span", this), 0.2, { x: -10, autoAlpha: 0, ease: Power1.easeInOut }),
                    scrollAble && TweenLite.to($(".half_img .bg.bg" + $(this).attr("data-hover")), 0.2, { opacity: 0, ease: Power1.easeOut });
            })
            .mouseup(function () {
                scrollAble && ((pagetransition = 2), $(".transition_bg .transition_image .bg").css("background-image", $(".half_img .bg.bg" + $(this).attr("data-hover")).css("background-image")));
            }),
        $(".footer .subscribe .submit")
            .mouseenter(function () {
                mouseevents.mousehover();
            })
            .mouseleave(function () {
                mouseevents.mouseout();
            })
            .mouseup(function () {
                $(".youremail").val() &&
                    (validateEmail($(".youremail").val())
                        ? $.ajax({
                              type: "POST",
                              url: ajaxurl,
                              data: { action: "subscribe", email: $(".youremail").val() },
                              success: function (e) {
                                  $(".footer .subscribe .submit").html("You've been added to our mailing list."), $(".footer .subscribe .subhead.submit").removeClass("submit");
                              },
                          })
                        : alert("Enter a valid Email Address."));
            }),
        $(".footer .credit.open")
            .mouseenter(function () {
                mouseevents.mousehover();
            })
            .mouseleave(function () {
                mouseevents.mouseout();
            })
            .mouseup(function () {
                TweenLite.to($(".footer .credit_overlay"), 1.2, { height: $(window).height(), ease: Power3.easeInOut });
            }),
        $(".footer .credit.close")
            .mouseenter(function () {
                mouseevents.mousehover();
            })
            .mouseleave(function () {
                mouseevents.mouseout();
            })
            .mouseup(function () {
                TweenLite.to($(".footer .credit_overlay"), 1.2, { height: 0, ease: Power3.easeInOut });
            }),
        $(".footer a")
            .mouseenter(function () {
                mouseevents.mousehover();
            })
            .mouseleave(function () {
                mouseevents.mouseout();
            }),
        isMobile ||
            (loading_animation_.pause(),
            TweenMax.to($("div.cursor #loader .circle"), 0.6, { drawSVG: "100%", ease: Power1.easeOut }),
            TweenMax.to($("div.cursor #loader"), 0.4, {
                autoAlpha: 1,
                ease: Power1.easeInOut,
                delay: 0.2,
                onComplete: function () {
                    loading_animation.pause();
                },
            }));
}
function aboutjs() {
    TweenLite.set([$(".scrolling_content"), $(".half_txt .entry.top"), $(".content.about .large_text")], { rotation: 0.01, force3D: !0 }),
        new SplitText(".half_txt .entry.top .bodytext", { type: "lines" }),
        TweenLite.set($(".half_txt .entry.top .bodytext"), { autoAlpha: 1 }),
        TweenMax.staggerFromTo($(".half_txt .entry.top .bodytext div"), 2, { autoAlpha: 0, rotation: -5, yPercent: -100 }, { autoAlpha: 1, rotation: 0, yPercent: 0, ease: Power3.easeOut, delay: 0.2 }, 0.04),
        TweenLite.set($(".footer"), { force3D: !0 }),
        TweenLite.set($(".parallax_bg_alt"), { force3D: !0 }),
        TweenLite.set($(".about_cover .bg"), { force3D: !0, rotation: 0.01 }),
        TweenMax.to($(".about_cover"), 1.2, { height: 0.75 * $(window).height(), ease: Power3.easeInOut, delay: 1 }),
        TweenMax.to($(".about_cover .bg"), 1.2, { scale: 1, ease: Power2.easeInOut, delay: 1.05 }),
        TweenLite.set([$(".insta_follow .insta_reel"), $(".insta_follow .article_title")], { force3D: !0, rotation: 0.01 }),
        new Instafeed({
            get: "user",
            userId: 1745315687,
            accessToken: "1745315687.aec3125.f73ac99b0afc47c3a7d5ce7339613157",
            template: '<a href="{{link}}" target="_blank" class="box" style="background-image: url({{image}});"></a>',
            resolution: "standard_resolution",
            limit: "8",
            useHttp: !0,
        }).run(),
        isMobile || TweenLite.to($("#scrollbar"), 0.2, { autoAlpha: 1 }),
        $(".insta_follow")
            .mouseenter(function () {
                (insta_hover = !0),
                    TweenLite.to($(".insta_follow .insta_reel"), 0.4, { autoAlpha: 1, ease: Power2.easeIn }),
                    TweenLite.to($(".cursor #loader"), 0.4, { autoAlpha: 0, ease: Power1.easeOut }),
                    TweenLite.to($(".cursor #drag"), 0.4, { autoAlpha: 1, ease: Power1.easeIn });
            })
            .mouseleave(function () {
                (insta_hover = !1),
                    TweenLite.to($(".insta_follow .insta_reel"), 0.4, { autoAlpha: 0, ease: Power2.easeOut }),
                    TweenLite.to($(".cursor #drag"), 0.4, { autoAlpha: 0, ease: Power1.easeOut }),
                    TweenLite.to($(".cursor #loader"), 0.4, { autoAlpha: 1, ease: Power1.easeIn });
            }),
        $(".footer .subscribe .submit")
            .mouseenter(function () {
                mouseevents.mousehover();
            })
            .mouseleave(function () {
                mouseevents.mouseout();
            })
            .mouseup(function () {
                $(".youremail").val() &&
                    (validateEmail($(".youremail").val())
                        ? $.ajax({
                              type: "POST",
                              url: ajaxurl,
                              data: { action: "subscribe", email: $(".youremail").val() },
                              success: function (e) {
                                  $(".footer .subscribe .submit").html("You've been added to our mailing list."), $(".footer .subscribe .subhead.submit").removeClass("submit");
                              },
                          })
                        : alert("Enter a valid Email Address."));
            }),
        $(".footer .credit.open")
            .mouseenter(function () {
                mouseevents.mousehover();
            })
            .mouseleave(function () {
                mouseevents.mouseout();
            })
            .mouseup(function () {
                TweenLite.to($(".footer .credit_overlay"), 1.2, { height: $(window).height(), ease: Power3.easeInOut });
            }),
        $(".footer .credit.close")
            .mouseenter(function () {
                mouseevents.mousehover();
            })
            .mouseleave(function () {
                mouseevents.mouseout();
            })
            .mouseup(function () {
                TweenLite.to($(".footer .credit_overlay"), 1.2, { height: 0, ease: Power3.easeInOut });
            }),
        $(".footer a")
            .mouseenter(function () {
                mouseevents.mousehover();
            })
            .mouseleave(function () {
                mouseevents.mouseout();
            }),
        isMobile ||
            (loading_animation_.pause(),
            TweenMax.to($("div.cursor #loader .circle"), 0.6, { drawSVG: "100%", ease: Power1.easeOut }),
            TweenMax.to($("div.cursor #loader"), 0.4, {
                autoAlpha: 1,
                ease: Power1.easeInOut,
                delay: 0.2,
                onComplete: function () {
                    loading_animation.pause();
                },
            }));
}
function articlejs() {
    if (
        (TweenLite.set($(".scrolling_content"), { rotation: 0.01, force3D: !0 }),
        TweenLite.set($(".main_article .cover_image"), { force3D: !0 }),
        TweenLite.set($(".main_article .cover_image .bg"), { rotation: 0.01 }),
        TweenLite.set([$(".cover_text"), $(".gallery"), $(".footer")], { force3D: !0 }),
        $("ingredients").length)
    ) {
        var e = $("ingredients").text().split("\n");
        if (isMobile && $(window).width() < 768) for (var t = 0; t < e.length; t++) 1 < e[t].length && $(".small_screen_ingredients .bodytext").append("<span>" + e[t] + "</span>");
        else {
            new SplitText(".article_content .article_entry .bodytext", { type: "lines" });
            for (t = 0; t < e.length; t++) 1 < e[t].length && $(".ingredients").append("<div class='bodytext'>" + e[t] + "</div>");
        }
        $("ingredients").remove();
    } else $(".ingredients").remove();
    $("gallery").length
        ? (4 == $("gallery img").length && 768 <= $(window).width() ? $(".gallery").css("height", "125vw") : 5 <= $("gallery img").length && 768 <= $(window).width() && $(".gallery").css("height", "135vw"),
          $("gallery img").each(function () {
              $(".gallery").append("<div class='picture'><div class='bg' style='background-image:url(" + $(this).attr("src") + ")'></div><div class='mask'></div></div>");
          }),
          isMobile || TweenLite.set($(".main_article .gallery .picture"), { rotation: 0.01, force3D: !0 }),
          $("gallery").remove())
        : $(".gallery").remove(),
        TweenLite.to($(".main_article .cover_image"), 1.6, { height: 0.8 * $(window).height(), y: 0, ease: Power4.easeInOut }),
        isMobile || TweenLite.to($("#scrollbar"), 0.2, { autoAlpha: 1 }),
        $(".fb_share")
            .mouseenter(function () {
                mouseevents.mousehover();
            })
            .mouseleave(function () {
                mouseevents.mouseout();
            }),
        $(".tw_share")
            .mouseenter(function () {
                mouseevents.mousehover();
            })
            .mouseleave(function () {
                mouseevents.mouseout();
            }),
        $(".next_article .article_title")
            .mouseenter(function () {
                mouseevents.mousehover();
            })
            .mouseleave(function () {
                mouseevents.mouseout();
            })
            .mouseup(function () {
                (pagetransition = 2), $(this).addClass("active"), $(".transition_bg .transition_image .bg").css("background-image", $(".next_article .cover .bg").css("background-image"));
            }),
        $("span.fb_share").mouseup(function () {
            window.open("https://www.facebook.com/sharer/sharer.php?u=" + escape(window.location.href) + "&t=" + document.title, "", "height=350,width=600");
        }),
        $("span.tw_share").mouseup(function () {
            window.open("https://twitter.com/share?url=" + escape(window.location.href), "", "height=350,width=600");
        }),
        $(".footer .subscribe .submit")
            .mouseenter(function () {
                mouseevents.mousehover();
            })
            .mouseleave(function () {
                mouseevents.mouseout();
            })
            .mouseup(function () {
                $(".youremail").val() &&
                    (validateEmail($(".youremail").val())
                        ? $.ajax({
                              type: "POST",
                              url: ajaxurl,
                              data: { action: "subscribe", email: $(".youremail").val() },
                              success: function (e) {
                                  $(".footer .subscribe .submit").html("You've been added to our mailing list."), $(".footer .subscribe .subhead.submit").removeClass("submit");
                              },
                          })
                        : alert("Enter a valid Email Address."));
            }),
        $(".footer .credit.open")
            .mouseenter(function () {
                mouseevents.mousehover();
            })
            .mouseleave(function () {
                mouseevents.mouseout();
            })
            .mouseup(function () {
                TweenLite.to($(".footer .credit_overlay"), 1.2, { height: $(window).height(), ease: Power3.easeInOut });
            }),
        $(".footer .credit.close")
            .mouseenter(function () {
                mouseevents.mousehover();
            })
            .mouseleave(function () {
                mouseevents.mouseout();
            })
            .mouseup(function () {
                TweenLite.to($(".footer .credit_overlay"), 1.2, { height: 0, ease: Power3.easeInOut });
            }),
        $(".footer a")
            .mouseenter(function () {
                mouseevents.mousehover();
            })
            .mouseleave(function () {
                mouseevents.mouseout();
            }),
        isMobile ||
            (loading_animation_.pause(),
            TweenMax.to($("div.cursor #loader .circle"), 0.6, { drawSVG: "100%", ease: Power1.easeOut }),
            TweenMax.to($("div.cursor #loader"), 0.4, {
                autoAlpha: 1,
                ease: Power1.easeInOut,
                delay: 0.2,
                onComplete: function () {
                    loading_animation.pause();
                },
            }));
}
function contactjs() {
    TweenLite.set([$(".content.contact .large_text")], { rotation: 0.01, force3D: !0 }),
        TweenLite.set($(".half_txt .contact_entry .bodytext"), { autoAlpha: 1 }),
        TweenMax.staggerFromTo($(".half_txt .contact_entry .bodytext div"), 2, { autoAlpha: 0, rotation: -3, yPercent: -150 }, { autoAlpha: 1, rotation: 0, yPercent: 0, ease: Power3.easeOut, delay: 0.2 }, 0.04),
        TweenMax.to($(".contact_cover"), 1.2, { height: 0.75 * $(window).height(), ease: Power3.easeInOut, delay: 1 }),
        TweenMax.to($(".contact_cover .bg"), 1.2, { scale: 1, ease: Power2.easeInOut, delay: 1.05 }),
        $(".half_txt .contact_entry .bodytext a")
            .mouseenter(function () {
                mouseevents.mousehover();
            })
            .mouseleave(function () {
                mouseevents.mouseout();
            }),
        isMobile ||
            (loading_animation_.pause(),
            TweenMax.to($("div.cursor #loader .circle"), 0.6, { drawSVG: "100%", ease: Power1.easeOut }),
            TweenMax.to($("div.cursor #loader"), 0.4, {
                autoAlpha: 1,
                ease: Power1.easeInOut,
                delay: 0.2,
                onComplete: function () {
                    loading_animation.pause();
                },
            }));
}
document.addEventListener("DOMContentLoaded", function () {
    isMobile ||
        (TweenLite.set([$(".cursor"), $(".pointer"), $("#scrollbar")], { force3D: !0 }),
        TweenLite.set($(".pointer"), { opacity: 1 }),
        TweenLite.to([$(".cursor")], 1, { opacity: 1 }),
        TweenLite.set($("#drag.line1"), { xPercent: 60 }),
        TweenLite.set($("#drag.line2"), { xPercent: -60 }),
        (loading_animation = new TimelineMax({ repeat: -1 })).fromTo("#loader", 1.65, { rotation: 0 }, { rotation: 360, ease: Power1.easeInOut, transformOrigin: "50% 50%" }),
        (loading_animation_ = new TimelineMax({ repeat: -1 }))
            .fromTo("#loader .circle", 0.8, { drawSVG: "0%", rotation: 0 }, { drawSVG: "90%", rotation: 360, ease: Power1.easeIn, force3D: !1, transformOrigin: "50% 50%" })
            .fromTo("div.cursor #loader .circle", 0.8, { drawSVG: "90%", rotation: 360 }, { drawSVG: "0%", rotation: 720, ease: Power1.easeOut, force3D: !1, transformOrigin: "50% 50%" }),
        (dragging_animation = new TimelineMax({ repeat: -1, paused: !0 }))
            .to("#drag.line1", 0.6, { xPercent: 65, ease: Power1.easeInOut })
            .to("#drag.line2", 0.6, { xPercent: -65, ease: Power1.easeInOut }, "-=0.6")
            .to("#drag.line1", 0.4, { xPercent: 60, ease: Power1.easeInOut })
            .to("#drag.line2", 0.4, { xPercent: -60, ease: Power1.easeInOut }, "-=0.4"),
        (logo_animation = new TimelineMax({ paused: !0, yoyo: !0 }))
            .to(".header svg path.m", 0.4, { autoAlpha: 0, ease: Power1.easeInOut })
            .to(".header svg path.e", 0.6, { xPercent: -56.5, ease: Power3.easeInOut }, "-=0.2")
            .to(".header svg circle", 0.4, { autoAlpha: 1, ease: Power1.easeInOut }, "-=0.2")),
        TweenLite.set([$(".header"), $(".transition_bg")], { rotation: 0.01, force3D: !0 }),
        TweenLite.set($(".menu_bg"), { force3D: !0 }),
        TweenLite.to([$(".header")], 1, { opacity: 1 }),
        TweenMax.staggerTo($(".loading_text .text div"), 1.6, { autoAlpha: 1, rotation: 0, y: 0, ease: Power2.easeOut, delay: 0.4 }, 0.03),
        Barba.Pjax.init(),
        Barba.Prefetch.init(),
        Barba.Dispatcher.on("linkClicked", function (e) {
            (inTransition = !0),
                isMobile ||
                    ($("div.top_menu a.active").removeClass("active"),
                    (scrollAble = !1),
                    TweenLite.set($("div.cursor #loader .circle"), { drawSVG: "0%" }),
                    TweenLite.to($("#scrollbar"), 0.2, { autoAlpha: 0 }),
                    TweenMax.to($("div.cursor #loader"), 0.4, {
                        autoAlpha: 1,
                        scale: 1,
                        ease: Power1.easeInOut,
                        onComplete: function () {
                            loading_animation_.restart(), loading_animation.restart();
                        },
                    }),
                    TweenLite.to($("div.menu_bg"), 0.6, { yPercent: -100, ease: Power2.easeInOut })),
                TweenLite.set($(".click_mask"), { autoAlpha: 1 });
        }),
        Barba.Dispatcher.on("transitionCompleted", function (e) {
            (inTransition = !1), isMobile || TweenLite.to($("div.menu_bg"), 0.6, { yPercent: 0, ease: Power2.easeInOut, delay: 1 }), TweenLite.set($(".click_mask"), { autoAlpha: 0 }), runscript(), (scrollAble = !0);
        }),
        Barba.BaseView.extend({
            namespace: "index",
            onLeave: function () {
                768 < $(window).width() &&
                    (clearTimeout(slidetimer),
                    TweenMax.killTweensOf($(".content.index .front_nav .next_prev .next_btn span")),
                    TweenLite.to($(".content.index .front_nav .next_prev .next_btn span"), 0.2, { scaleX: 0, ease: Power1.easeInOut }),
                    TweenLite.to($(".content.index .front_nav"), 0.8, { yPercent: 100, ease: Power2.easeInOut, delay: 0.2 }));
            },
        }).init();
    var e = Barba.BaseTransition.extend({
        start: function () {
            Promise.all([this.newContainerLoading, this.scrolldelay()]).then(this.movePages.bind(this));
        },
        scrolldelay: function () {
            var e = Barba.Utils.deferred(),
                t = $(window).scrollTop();
            return (
                TweenLite.to($(window), 0.01, {
                    ease: Power4.easeInOut,
                    onUpdate: function () {
                        $(window).scrollTop(t);
                    },
                    onComplete: function () {
                        e.resolve();
                    },
                }),
                e.promise
            );
        },
        movePages: function () {
            var e = this,
                t = this.newContainer;
            (this.newContainer.style.zIndex = "9"),
                TweenLite.set(t, { visibility: "visible", position: "fixed", opacity: 0, top: 0, left: 0 }),
                1 == pagetransition
                    ? ((pagetransition = 0),
                      $(".transition_bg .large_text").html(loading_text[pagetransitiontext]),
                      TweenMax.staggerFromTo($(".transition_bg .large_text div"), 1.6, { autoAlpha: 0, yPercent: 50 }, { autoAlpha: 1, yPercent: 0, ease: Power2.easeOut, delay: 0.2 }, 0.02),
                      TweenLite.to($(".transition_bg"), 1.6, {
                          height: $(window).height(),
                          ease: Power4.easeInOut,
                          onComplete: function () {
                              TweenLite.set(t, { opacity: 1 }),
                                  $(".transition_bg").css({ bottom: "0px", top: "auto" }),
                                  $(".transition_bg .large_text").css({ bottom: "22.5vh", top: "auto" }),
                                  (scrollTagergetY = scrollY = 0),
                                  TweenLite.set(e.newContainer, { clearProps: "all" }),
                                  e.done();
                          },
                      }),
                      TweenLite.to($(".transition_bg"), 1.6, {
                          height: 0,
                          delay: 1.6,
                          ease: Power4.easeInOut,
                          onComplete: function () {
                              $(".transition_bg").css({ top: "0px", bottom: "auto" }), $(".transition_bg .large_text").css({ top: "22.5vh", bottom: "auto" }), $(".transition_bg .large_text").html("");
                          },
                      }))
                    : 2 == pagetransition
                    ? ((pagetransition = 0),
                      TweenLite.set($(".transition_bg .transition_image"), { autoAlpha: 1 }),
                      TweenLite.to($(".transition_bg"), 1.6, {
                          height: $(window).height(),
                          ease: Power4.easeInOut,
                          onComplete: function () {
                              TweenLite.set(t, { opacity: 1 }),
                                  $(".transition_bg").css({ height: "0px" }),
                                  TweenLite.set($(".transition_bg .transition_image"), { autoAlpha: 0 }),
                                  TweenLite.set(e.newContainer, { clearProps: "all" }),
                                  e.done(),
                                  (scrollTagergetY = scrollY = 0);
                          },
                      }))
                    : 0 == pagetransition &&
                      (TweenMax.staggerFromTo($(".transition_bg .default_transition .text div"), 1.6, { autoAlpha: 0, rotation: 1, yPercent: 50 }, { autoAlpha: 1, rotation: 0, yPercent: 0, ease: Power2.easeOut, delay: 0.4 }, 0.03),
                      TweenLite.to($(".transition_bg"), 1.6, {
                          height: $(window).height(),
                          ease: Power4.easeInOut,
                          onComplete: function () {
                              TweenLite.set(t, { opacity: 1 }),
                                  $(".transition_bg").css({ bottom: "0px", top: "auto" }),
                                  $(".transition_bg .default_transition").css({ bottom: "10vw", top: "auto" }),
                                  (scrollTagergetY = scrollY = 0),
                                  TweenLite.set(e.newContainer, { clearProps: "all" }),
                                  e.done();
                          },
                      }),
                      TweenLite.to($(".transition_bg"), 1.6, {
                          height: 0,
                          delay: 1.6,
                          ease: Power4.easeInOut,
                          onComplete: function () {
                              $(".transition_bg").css({ top: "0px", bottom: "auto" }),
                                  $(".transition_bg .default_transition").css({ top: "10vw", bottom: "auto" }),
                                  TweenLite.set($(".transition_bg .default_transition .text div"), { autoAlpha: 0 });
                          },
                      }));
        },
        getNewPageFile: function () {
            return Barba.HistoryManager.currentStatus().url.split("/").pop();
        },
    });
    Barba.Pjax.getTransition = function () {
        return e;
    };
    for (var t = document.querySelectorAll("a[href]"), o = 0; o < t.length; o++) t[o].addEventListener("click", cbk);
    isMobile
        ? ($("div.menu_button").css("display", "inline-block"),
          $("div.menu_bg").css("display", "none"),
          $(".header .logo").click(function () {
              $("div.menu_button").hasClass("open") &&
                  ($("div.menu_button").removeClass("open"),
                  TweenLite.to($(".mobile_menu"), 0.8, {
                      width: 0,
                      ease: Power2.easeInOut,
                      onComplete: function () {
                          TweenLite.set($("div.mobile_menu .menu_items a"), { autoAlpha: 0 });
                      },
                  }));
          }),
          $("div.menu_button").click(function () {
              $(this).toggleClass("open"),
                  $(this).hasClass("open")
                      ? (TweenLite.to($(".mobile_menu"), 0.8, { width: $(window).width(), ease: Power2.easeInOut }),
                        TweenMax.staggerFromTo($("div.mobile_menu .menu_items a"), 1.6, { autoAlpha: 0, rotation: 5, yPercent: 150 }, { autoAlpha: 1, rotation: 0, yPercent: 0, ease: Power3.easeOut }, 0.04))
                      : TweenLite.to($(".mobile_menu"), 0.8, {
                            width: 0,
                            ease: Power2.easeInOut,
                            onComplete: function () {
                                TweenLite.set($("div.mobile_menu .menu_items a"), { autoAlpha: 0 });
                            },
                        });
          }),
          $(".mobile_menu .menu_items a").click(function () {
              scrollAble &&
                  ($("div.menu_button").removeClass("open"),
                  TweenLite.to($(".mobile_menu"), 0.8, {
                      width: 0,
                      ease: Power2.easeInOut,
                      onComplete: function () {
                          TweenLite.set($("div.mobile_menu .menu_items a"), { autoAlpha: 0 });
                      },
                  }),
                  (pagetransition = 1),
                  $(this).hasClass("eats")
                      ? (pagetransitiontext = 1)
                      : $(this).hasClass("yoga")
                      ? (pagetransitiontext = 2)
                      : $(this).hasClass("events")
                      ? (pagetransitiontext = 3)
                      : $(this).hasClass("about")
                      ? (pagetransitiontext = 4)
                      : $(this).hasClass("contact") && (pagetransitiontext = 5));
          }))
        : (((jsscroller = document.querySelector("#scrollbar .scroller")).onmousedown = function (e) {
              (scrollAble = !(dragging = !0)), (mouseYscrollbar = e.clientY), (mouseYscroller = jsscroller.offsetTop);
          }),
          $(".header .logo")
              .mouseenter(function () {
                  logo_animation.reverse(), mouseevents.mousehover();
              })
              .mouseleave(function () {
                  logo_animation.play(), mouseevents.mouseout();
              }),
          $("div.top_menu a")
              .mouseenter(function () {
                  mouseevents.mousehover();
              })
              .mouseleave(function () {
                  mouseevents.mouseout();
              })
              .mouseup(function () {
                  TweenLite.to($(".pointer #pointer"), 0.2, { scale: 1, autoAlpha: 0, ease: Power1.easeOut, force3D: !1 }),
                      $(".content").hasClass("index") && (TweenLite.set($(".cursor"), { autoAlpha: 1 }), TweenLite.set($(".cursor #drag"), { autoAlpha: 0 })),
                      (pagetransition = 1),
                      $(this).hasClass("eats")
                          ? (pagetransitiontext = 1)
                          : $(this).hasClass("yoga")
                          ? (pagetransitiontext = 2)
                          : $(this).hasClass("events")
                          ? (pagetransitiontext = 3)
                          : $(this).hasClass("about")
                          ? (pagetransitiontext = 4)
                          : $(this).hasClass("contact") && (pagetransitiontext = 5);
              }));
}),
    window.addEventListener("load", function () {
        scrollrun(),
            setTimeout(function () {
                runscript();
            }, 0),
            TweenMax.to($(".loading_mask"), 1.6, {
                height: 0,
                ease: Power4.easeInOut,
                delay: 0,
                onComplete: function () {
                    (scrollAble = !0),
                        TweenLite.set([$(".loading_mask"), $(".click_mask")], { autoAlpha: 0 }),
                        isMobile || (logo_animation.play(), TweenLite.set($(".menu_bg"), { autoAlpha: 1 }), TweenMax.staggerTo($("div.top_menu a"), 0.4, { autoAlpha: 1, yPercent: 50, ease: Power1.easeOut }, 0.02));
                },
            });
    }),
    (window.onmousemove = function (e) {
        if (!isMobile && ((cursor.y = e.clientY), (cursor.x = e.clientX), 1 == dragging)) {
            var t = Math.max(Math.min(Math.round(e.clientY - mouseYscrollbar + mouseYscroller), $("#scrollbar").height() - $("#scrollbar .scroller").height()), 0);
            return (
                TweenLite.set(jsscroller, { top: t }), (scrollTagergetY = -Math.round((jsscroller.offsetTop / ($("#scrollbar").height() - $("#scrollbar .scroller").height())) * ($(".scrolling_content").height() - $(window).height()))), !1
            );
        }
    }),
    (window.onmouseup = function (e) {
        dragging && !isMobile && (dragging = !(scrollAble = !0));
    });
var scrollrun = function () {
    requestAnimationFrame(scrollrun),
        isMobile ||
            ((targetCursor.x += 0.15 * (cursor.x - targetCursor.x)),
            (targetCursor.y += 0.15 * (cursor.y - targetCursor.y)),
            $(".insta_follow").length && ((insta_target += 0.05 * (cursor.x - insta_target)), TweenLite.set($(".insta_follow .insta_reel"), { xPercent: insta_target / -40 })),
            TweenLite.set([$(".cursor"), $(".pointer")], { x: targetCursor.x, y: targetCursor.y })),
        (scrollAble || dragging) &&
            ($(".content").hasClass("cate")
                ? ((scrollY += 0.065 * (scrollTagergetY - scrollY)),
                  TweenLite.set($(".scrolling_content"), { y: scrollY }),
                  isMobile || TweenLite.set(jsscroller, { top: (-($("#scrollbar").height() - $("#scrollbar .scroller").height()) * scrollY) / ($(".scrolling_content").height() - $(window).height()) }),
                  -1 * scrollY < 2 * $(window).height() &&
                      (TweenLite.set($(".entry.top"), { yPercent: scrollY / -75 }), -1 * scrollY < 0.5 * $(window).height() && TweenLite.set($(".content.cate .large_text"), { autoAlpha: 1 - scrollY / -$(window).height() / 0.54 })),
                  -1 * scrollY < $(".scrolling_content").height() - 1 * $(window).height() && TweenLite.set($(".footer"), { y: -1.5 * (-1 * scrollY - $(".scrolling_content").height() + $(window).height()) }),
                  $(".parallax_bg").each(function () {
                      $(this).offset().top - $(window).height() < 0 &&
                          $(this).offset().top > -1 * $(this).height() &&
                          (TweenLite.set($(".bg", this), { yPercent: ((-1 * ($(this).offset().top - $(window).height())) / $(window).height()) * $(this).attr("data-velocity") }),
                          TweenLite.set($(this), { yPercent: (((-1 * ($(this).offset().top - $(window).height())) / $(window).height()) * $(this).attr("data-velocity")) / -1 }));
                  }),
                  $(".entry.hover_entry").each(function () {
                      $(this).offset().top - $(window).height() < 0 && !$(this).hasClass("active") && ($(this).addClass("active"), TweenMax.to($(".title", this), 1.6, { opacity: 1, rotation: 0, y: 0, ease: Power4.easeOut, delay: 0.2 }));
                  }))
                : $(".content").hasClass("about")
                ? ((scrollY += 0.065 * (scrollTagergetY - scrollY)),
                  TweenLite.set($(".scrolling_content"), { y: scrollY }),
                  isMobile || TweenLite.set(jsscroller, { top: (-($("#scrollbar").height() - $("#scrollbar .scroller").height()) * scrollY) / ($(".scrolling_content").height() - $(window).height()) }),
                  -1 * scrollY < 2 * $(window).height() &&
                      (TweenLite.set($(".entry.top"), { yPercent: scrollY / -75 }),
                      TweenLite.set($(".about_cover"), { yPercent: scrollY / 10 }),
                      TweenLite.set($(".about_cover .bg"), { yPercent: scrollY / -200 }),
                      TweenLite.set($(".content.about .large_text"), { autoAlpha: 1 - scrollY / -$(window).height() / 1 })),
                  -1 * scrollY < $(".scrolling_content").height() - $(window).height() && TweenLite.set($(".footer"), { y: -1.5 * (-1 * scrollY - $(".scrolling_content").height() + $(window).height()) }),
                  $(".insta_follow").offset().top - $(window).height() < 0 &&
                      $(".insta_follow").offset().top > -1 * $(".insta_follow").height() &&
                      TweenLite.set($(".insta_follow .article_title"), { xPercent: ((-1 * ($(".insta_follow").offset().top - $(window).height())) / $(window).height()) * 12 }),
                  !isMobile &&
                      768 < $(window).width() &&
                      ($(".parallax_bg").each(function () {
                          $(this).offset().top - $(window).height() < 0 &&
                              $(this).offset().top > -1 * $(this).height() &&
                              TweenLite.set($(".bg", this), { yPercent: ((-1 * ($(this).offset().top - $(window).height())) / $(window).height()) * $(this).attr("data-velocity") });
                      }),
                      $(".parallax_bg_alt").each(function () {
                          $(this).offset().top - $(window).height() < 0 &&
                              $(this).offset().top > -1 * $(this).height() &&
                              (TweenLite.set($(".bg", this), { yPercent: ((-1 * ($(this).offset().top - $(window).height())) / $(window).height()) * $(this).attr("data-velocity") }),
                              TweenLite.set($(this), { yPercent: (((-1 * ($(this).offset().top - $(window).height())) / $(window).height()) * $(this).attr("data-velocity")) / -1 }));
                      })))
                : $(".content").hasClass("article") &&
                  ((scrollY += 0.065 * (scrollTagergetY - scrollY)),
                  TweenLite.set($(".scrolling_content"), { y: scrollY }),
                  isMobile || TweenLite.set(jsscroller, { top: (-($("#scrollbar").height() - $("#scrollbar .scroller").height()) * scrollY) / ($(".scrolling_content").height() - $(window).height()) }),
                  -1 * scrollY < 2 * $(window).height() && (TweenLite.set($(".cover_image .bg"), { yPercent: scrollY / -50 }), TweenLite.set($(".cover_text"), { yPercent: scrollY / -25 })),
                  -1 * scrollY < $(".scrolling_content").height() - $(window).height() && TweenLite.set($(".footer"), { y: -1.5 * (-1 * scrollY - $(".scrolling_content").height() + $(window).height()) }),
                  -1 * scrollY < $(window).height() && 1 == $(".content_share").css("opacity")
                      ? TweenLite.to($(".content_share"), 0.2, { autoAlpha: 0 })
                      : -1 * scrollY >= $(window).height() && 0 == $(".content_share").css("opacity") && TweenLite.to($(".content_share"), 0.2, { autoAlpha: 1 }),
                  $(".article_content .article_entry").each(function () {
                      $(this).hasClass("active") ||
                          ($(this).offset().top - $(window).height() < 0 && ($(this).addClass("active"), TweenMax.staggerTo($(".bodytext div", this), 1.6, { opacity: 1, rotation: 0, y: 0, ease: Power4.easeOut, delay: 0.2 }, 0.05)));
                  }),
                  768 <= $(window).width() &&
                      $(".main_article .gallery .picture").each(function () {
                          $(this).hasClass("active") || ($(this).offset().top - $(window).height() < 0 && ($(this).addClass("active"), TweenLite.to($(".mask", this), 1.2, { scaleX: 0, ease: Power3.easeInOut })));
                      })));
};
VirtualScroll.on(function (e) {
    if (scrollAble) {
        var t = e.deltaY || e.deltaX;
        (t *= windowsMulti),
            $(".content").hasClass("index")
                ? ((scrollAble = !1),
                  0 < t
                      ? (TweenMax.killTweensOf($(".content.index .front_nav .next_prev .next_btn span")),
                        TweenLite.to($(".content.index .front_nav .next_prev .next_btn span"), 0.2, { scaleX: 0, ease: Power1.easeInOut }),
                        indexslideshow.index_prev())
                      : (TweenMax.killTweensOf($(".content.index .front_nav .next_prev .next_btn span")), indexslideshow.index_next()))
                : ($(".content").hasClass("cate") || $(".content").hasClass("about") || $(".content").hasClass("article")) &&
                  (isMobile || (0 < t ? TweenLite.to($("div.menu_bg"), 0.6, { yPercent: 0, ease: Power2.easeInOut }) : TweenLite.to($("div.menu_bg"), 0.6, { yPercent: -100, ease: Power2.easeInOut })),
                  0 <= (scrollTagergetY += t / 2)
                      ? (scrollTagergetY = 0)
                      : scrollTagergetY <= -1 * ($(".scrolling_content").height() - $(window).height()) && (scrollTagergetY = -1 * ($(".scrolling_content").height() - $(window).height())));
    }
});
var indexslideshow = new (function () {
        (this.slideshowplay = function () {
            $(".content").hasClass("index") &&
                TweenLite.to($(".content.index .front_nav .next_prev .next_btn span"), 5, {
                    scaleX: 1,
                    transformOrigin: "0% 50%",
                    onComplete: function () {
                        (scrollAble = !1), indexslideshow.index_next();
                    },
                });
        }),
            (this.index_next = function () {
                768 < $(window).width()
                    ? (clearTimeout(slidetimer),
                      $(".content.index .large_bg .bg").css({ left: "auto", right: "0px" }),
                      $(".content.index .large_bg .obj_bg ").css({ left: "auto", right: "0px" }),
                      $(".content.index .active_detail ").css({ left: "auto", right: "0px" }),
                      $(".content.index .small_bg .bg").css({ top: "0px", bottom: "auto" }),
                      $(".content.index .small_bg .obj_bg ").css({ top: "0px", bottom: "auto" }),
                      $(".content.index .next_detail ").css({ top: "22.5vh", bottom: "auto" }),
                      5 < ++index_scroll_large && (index_scroll_large = 1),
                      5 < ++index_scroll_small && (index_scroll_small = 1),
                      TweenLite.set($(".large_bg .bg" + index_scroll_large), { zIndex: 3 }),
                      TweenLite.set($(".small_bg .bg" + index_scroll_small), { zIndex: 3 }),
                      1 == index_scroll_large && TweenLite.set($(".large_bg .bg5"), { zIndex: 2 }),
                      1 == index_scroll_small && TweenLite.set($(".small_bg .bg5"), { zIndex: 2 }),
                      $(".open_page a").attr("href", $(".large_bg .bg" + index_scroll_large + " .active_detail a").attr("href")),
                      isMobile ||
                          (TweenMax.to($("div.cursor #drag"), 0.2, { autoAlpha: 0, ease: Power1.easeOut }),
                          TweenLite.set($("div.cursor #loader .circle"), { drawSVG: "0%", rotation: -90 }),
                          TweenLite.set($("div.cursor #loader"), { autoAlpha: 1, rotation: 0 }),
                          TweenLite.to($("div.cursor #loader .circle"), 1.2, {
                              drawSVG: "100%",
                              ease: Power3.easeInOut,
                              onComplete: function () {
                                  inTransition || TweenLite.to($("div.cursor #drag"), 0.3, { autoAlpha: 1, ease: Power1.easeIn });
                              },
                          }),
                          TweenLite.to($("div.cursor #loader"), 0.4, { autoAlpha: 0, delay: 0.8, ease: Power1.easeOut })),
                      TweenLite.to($(".content.index .front_nav .next_prev .next_btn span"), 0.2, { scaleX: 0, transformOrigin: "100% 50%", ease: Power1.easeInOut }),
                      TweenLite.fromTo(
                          $(".content.index .front_nav .slide span"),
                          0.8,
                          { opacity: 1, yPercent: 0 },
                          {
                              opacity: 0,
                              yPercent: 20,
                              ease: Power2.easeInOut,
                              onComplete: function () {
                                  $(".content.index .front_nav .slide span").html("0" + index_scroll_large),
                                      TweenLite.fromTo($(".content.index .front_nav .slide span"), 0.8, { opacity: 0, yPercent: -20 }, { opacity: 1, yPercent: 0, ease: Power2.easeInOut });
                              },
                          }
                      ),
                      TweenLite.fromTo($(".large_bg .bg" + index_scroll_large), 1.6, { width: 0 }, { width: 0.6 * $(window).width(), ease: Power4.easeInOut }),
                      TweenLite.fromTo($(".large_bg .bg" + index_scroll_large + " .obj_bg"), 1.6, { scale: 1.1 }, { scale: 1, ease: Power1.easeInOut }),
                      TweenMax.staggerFromTo(
                          $(".large_bg .bg" + index_scroll_large + " .active_detail .cover_title div"),
                          2.4,
                          { autoAlpha: 0, rotation: 1, yPercent: 30 },
                          { autoAlpha: 1, rotation: 0, yPercent: 0, ease: Power3.easeOut, delay: 0.1, force3D: !0 },
                          0.01
                      ),
                      TweenMax.staggerFromTo(
                          $(".large_bg .bg" + index_scroll_large + " .active_detail .open_link div"),
                          2.4,
                          { autoAlpha: 0, rotation: 1, yPercent: 150 },
                          { autoAlpha: 1, rotation: 0, yPercent: 0, ease: Power3.easeOut, delay: 0.15, force3D: !0 },
                          0.02
                      ),
                      TweenLite.fromTo($(".small_bg .bg" + index_scroll_small), 1.6, { height: 0 }, { height: $(window).height(), ease: Power4.easeInOut }),
                      TweenLite.fromTo(
                          $(".small_bg .bg" + index_scroll_small + " .obj_bg"),
                          1.6,
                          { scale: 1.1 },
                          {
                              scale: 1,
                              ease: Power1.easeInOut,
                              onComplete: function () {
                                  inTransition ||
                                      ((scrollAble = !0),
                                      5 == index_scroll_large && TweenLite.set($(".large_bg .bg" + index_scroll_large), { zIndex: 1 }),
                                      5 == index_scroll_small && TweenLite.set($(".small_bg .bg" + index_scroll_small), { zIndex: 1 }),
                                      TweenLite.set($(".large_bg .bg" + index_scroll_large).siblings(), { zIndex: 1, width: 0 }),
                                      TweenLite.set($(".small_bg .bg" + index_scroll_small).siblings(), { zIndex: 1, height: 0 }),
                                      (slidetimer = setTimeout(indexslideshow.slideshowplay, 3e3)));
                              },
                          }
                      ))
                    : ($(".content.index .large_bg .bg").css({ left: "auto", right: "0px" }),
                      $(".content.index .large_bg .obj_bg ").css({ left: "auto", right: "0px" }),
                      $(".content.index .active_detail").css({ left: "auto", right: "0px" }),
                      5 < ++index_scroll_large && (index_scroll_large = 1),
                      TweenLite.set($(".large_bg .bg" + index_scroll_large), { zIndex: 3 }),
                      1 == index_scroll_large && TweenLite.set($(".large_bg .bg5"), { zIndex: 2 }),
                      $(".open_page a").attr("href", $(".large_bg .bg" + index_scroll_large + " .active_detail a").attr("href")),
                      TweenLite.fromTo($(".large_bg .bg" + index_scroll_large), 1.6, { width: 0 }, { width: $(window).width(), ease: Power4.easeInOut }),
                      TweenLite.fromTo(
                          $(".large_bg .bg" + index_scroll_large + " .obj_bg"),
                          1.6,
                          { scale: 1.1 },
                          {
                              scale: 1,
                              ease: Power1.easeInOut,
                              onComplete: function () {
                                  inTransition ||
                                      ((scrollAble = !0),
                                      5 == index_scroll_large && TweenLite.set($(".large_bg .bg" + index_scroll_large), { zIndex: 1 }),
                                      TweenLite.set($(".large_bg .bg" + index_scroll_large).siblings(), { zIndex: 1, width: 0 }));
                              },
                          }
                      ),
                      TweenMax.staggerFromTo(
                          $(".large_bg .bg" + index_scroll_large + " .active_detail .cover_title div"),
                          2.4,
                          { autoAlpha: 0, rotation: 1, yPercent: 30 },
                          { autoAlpha: 1, rotation: 0, yPercent: 0, ease: Power3.easeOut, delay: 0.1, force3D: !0 },
                          0.01
                      ),
                      TweenMax.staggerFromTo(
                          $(".large_bg .bg" + index_scroll_large + " .active_detail .open_link div"),
                          2.4,
                          { autoAlpha: 0, rotation: 1, yPercent: 150 },
                          { autoAlpha: 1, rotation: 0, yPercent: 0, ease: Power3.easeOut, delay: 0.15, force3D: !0 },
                          0.02
                      ));
            }),
            (this.index_prev = function () {
                768 < $(window).width()
                    ? (clearTimeout(slidetimer),
                      $(".content.index .large_bg .bg").css({ left: "0px", right: "auto" }),
                      $(".content.index .large_bg .obj_bg ").css({ left: "0px", right: "auto" }),
                      $(".content.index .active_detail ").css({ left: "0px", right: "auto" }),
                      $(".content.index .small_bg .bg").css({ bottom: "0px", top: "auto" }),
                      $(".content.index .small_bg .obj_bg ").css({ bottom: "0px", top: "auto" }),
                      $(".content.index .next_detail ").css({ bottom: "22.5vh", top: "auto" }),
                      --index_scroll_large < 1 && (index_scroll_large = 5),
                      --index_scroll_small < 1 && (index_scroll_small = 5),
                      TweenLite.set($(".large_bg .bg" + index_scroll_large), { zIndex: 3 }),
                      TweenLite.set($(".small_bg .bg" + index_scroll_small), { zIndex: 3 }),
                      TweenLite.set($(".large_bg .bg" + (index_scroll_large + 1)), { zIndex: 2 }),
                      TweenLite.set($(".small_bg .bg" + (index_scroll_small + 1)), { zIndex: 2 }),
                      $(".open_page a").attr("href", $(".large_bg .bg" + index_scroll_large + " .active_detail a").attr("href")),
                      isMobile ||
                          (TweenMax.to($("div.cursor #drag"), 0.2, { autoAlpha: 0, ease: Power1.easeOut }),
                          TweenLite.set($("div.cursor #loader .circle"), { drawSVG: "0%", rotation: -90 }),
                          TweenLite.set($("div.cursor #loader"), { autoAlpha: 1, rotation: 0 }),
                          TweenLite.to($("div.cursor #loader .circle"), 1.2, {
                              drawSVG: "100%",
                              ease: Power3.easeInOut,
                              onComplete: function () {
                                  inTransition || TweenLite.to($("div.cursor #drag"), 0.3, { autoAlpha: 1, ease: Power1.easeIn });
                              },
                          }),
                          TweenLite.to($("div.cursor #loader"), 0.4, { autoAlpha: 0, delay: 0.8, ease: Power1.easeOut })),
                      TweenLite.to($(".content.index .front_nav .next_prev .prev_btn span"), 0.2, { scaleX: 0, transformOrigin: "100% 50%", ease: Power1.easeInOut }),
                      TweenLite.fromTo(
                          $(".content.index .front_nav .slide span"),
                          0.8,
                          { opacity: 1, yPercent: 0 },
                          {
                              opacity: 0,
                              yPercent: -20,
                              ease: Power2.easeInOut,
                              onComplete: function () {
                                  $(".content.index .front_nav .slide span").html("0" + index_scroll_large),
                                      TweenLite.fromTo($(".content.index .front_nav .slide span"), 0.8, { opacity: 0, yPercent: 20 }, { opacity: 1, yPercent: 0, ease: Power2.easeInOut });
                              },
                          }
                      ),
                      TweenLite.fromTo($(".large_bg .bg" + index_scroll_large), 1.6, { width: 0 }, { width: 0.6 * $(window).width(), ease: Power4.easeInOut }),
                      TweenLite.fromTo($(".large_bg .bg" + index_scroll_large + " .obj_bg"), 1.6, { scale: 1.1 }, { scale: 1, ease: Power1.easeInOut }),
                      TweenMax.staggerFromTo(
                          $(".large_bg .bg" + index_scroll_large + " .active_detail .cover_title div"),
                          2,
                          { autoAlpha: 0, rotation: 1, yPercent: 30 },
                          { autoAlpha: 1, rotation: 0, yPercent: 0, ease: Power4.easeOut, delay: 0.1, force3D: !0 },
                          0.01
                      ),
                      TweenMax.staggerFromTo(
                          $(".large_bg .bg" + index_scroll_large + " .active_detail .open_link div"),
                          2,
                          { autoAlpha: 0, rotation: 1, yPercent: 150 },
                          { autoAlpha: 1, rotation: 0, yPercent: 0, ease: Power4.easeOut, delay: 0.15, force3D: !0 },
                          0.02
                      ),
                      TweenLite.fromTo($(".small_bg .bg" + index_scroll_small), 1.6, { height: 0 }, { height: $(window).height(), ease: Power4.easeInOut }),
                      TweenLite.fromTo(
                          $(".small_bg .bg" + index_scroll_small + " .obj_bg"),
                          1.6,
                          { scale: 1.1 },
                          {
                              scale: 1,
                              ease: Power1.easeInOut,
                              onComplete: function () {
                                  inTransition ||
                                      ((scrollAble = !0),
                                      TweenLite.set($(".large_bg .bg" + index_scroll_large).siblings(), { zIndex: 1 }),
                                      TweenLite.set($(".small_bg .bg" + index_scroll_small).siblings(), { zIndex: 1 }),
                                      (slidetimer = setTimeout(indexslideshow.slideshowplay, 3e3)));
                              },
                          }
                      ))
                    : ($(".content.index .large_bg .bg").css({ left: "0px", right: "auto" }),
                      $(".content.index .large_bg .obj_bg ").css({ left: "0px", right: "auto" }),
                      $(".content.index .active_detail ").css({ left: "0px", right: "auto" }),
                      --index_scroll_large < 1 && (index_scroll_large = 5),
                      TweenLite.set($(".large_bg .bg" + index_scroll_large), { zIndex: 3 }),
                      TweenLite.set($(".large_bg .bg" + (index_scroll_large + 1)), { zIndex: 2 }),
                      $(".open_page a").attr("href", $(".large_bg .bg" + index_scroll_large + " .active_detail a").attr("href")),
                      TweenLite.fromTo($(".large_bg .bg" + index_scroll_large), 1.6, { width: 0 }, { width: $(window).width(), ease: Power4.easeInOut }),
                      TweenLite.fromTo(
                          $(".large_bg .bg" + index_scroll_large + " .obj_bg"),
                          1.6,
                          { scale: 1.1 },
                          {
                              scale: 1,
                              ease: Power1.easeInOut,
                              onComplete: function () {
                                  inTransition || ((scrollAble = !0), TweenLite.set($(".large_bg .bg" + index_scroll_large).siblings(), { zIndex: 1 }));
                              },
                          }
                      ),
                      TweenMax.staggerFromTo(
                          $(".large_bg .bg" + index_scroll_large + " .active_detail .cover_title div"),
                          2,
                          { autoAlpha: 0, rotation: 1, yPercent: 30 },
                          { autoAlpha: 1, rotation: 0, yPercent: 0, ease: Power4.easeOut, delay: 0.1, force3D: !0 },
                          0.01
                      ),
                      TweenMax.staggerFromTo(
                          $(".large_bg .bg" + index_scroll_large + " .active_detail .open_link div"),
                          2,
                          { autoAlpha: 0, rotation: 1, yPercent: 150 },
                          { autoAlpha: 1, rotation: 0, yPercent: 0, ease: Power4.easeOut, delay: 0.15, force3D: !0 },
                          0.02
                      ));
            });
    })(),
    mouseevents = new (function () {
        (this.mousehover = function () {
            isMobile || (TweenLite.to($(".pointer #pointer"), 0.4, { scale: 1.6, autoAlpha: 0.2, ease: Power2.easeInOut, force3D: !1 }), TweenLite.to($(".cursor"), 0.2, { autoAlpha: 0, ease: Power2.easeOut }));
        }),
            (this.mouseout = function () {
                isMobile || (TweenLite.to($(".pointer #pointer"), 0.2, { scale: 1, autoAlpha: 0, ease: Power1.easeOut, force3D: !1 }), TweenLite.to($(".cursor"), 0.2, { autoAlpha: 1, ease: Power1.easeIn }));
            });
    })();
